<template>
  <div>
    <div class="sy-cell_around header">
      <div v-for="(item, index) in orderName" :key="index" :class="{'orderItem':true,'orderborder':item.active}" @click="tabName(item.id)">
        {{ item.name }}
      </div>
    </div>
    <div class="list">
      <div class="sy-cell_between hd">
        <div class="sy-cell name">
          新美特 <van-icon name="arrow" />
        </div>
        <div class="sy-cell state">
          交易完成 <van-icon name="delete" />
        </div>
      </div>
      <div class="sy-cell_flexStart goods-item">
        <img src="https://file.36krcdn.com/20190623/v2_1561302515667_file_000" class="goods-img">
        <div class="goodtext">
          <div class="title">
            心美特   Fora   xxxxxxxxxxxxxxxxxxxxx
          </div>
          <div class="goods-sku">
            Fora  型号说明
          </div>
        </div>
        <div class="money">
          <span class="font9">￥</span>199<br>
          <span class="font9">X1</span>
        </div>
      </div>
      <div class="much_text">
        共一件商品  合计¥<span class="font14">407.80</span>
      </div>
      <div class="sy-cell_flexEnd">
        <button class="buttons">
          查看物流
        </button>
        <button class="buttons buttonscolor">
          评价
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderList',
  data() {
    return {
      orderName: [
        {
          name: '全部',
          id: 0,
          active: true
        },
        {
          name: '待付款',
          id: 1,
          active: false
        },
        {
          name: '待发货',
          id: 2,
          active: false
        },
        {
          name: '待收货',
          id: 3,
          active: false
        },
        {
          name: '待评价',
          id: 4,
          active: false
        }
      ]
    }
  },
  methods: {
    tabName(index) {
      this.orderName.forEach(item => {
        item.active = false
        if (item.id === index) {
          item.active = true
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.van-icon{
    margin-left:12px;
}
.header{
    height: 44px;
    background:#fff;

    .orderborder{
        color:#FF760E;
        font-weight: 500;
        position: relative;
    }
    .orderborder::after {
        content: '';
        position: absolute;
        bottom: -10px;
        width: 100%;
        height: 2px;
        background: #FF760E;
    }
}
.list{
    padding:12px;
    background:#fff;
    margin-top: 10px;
    .hd{
        margin-bottom:12px;
    }
    .goods-item{
    margin-bottom:20px;
    align-items: flex-start;
  }
  .goods-img{
    width: 85px;
    height: 85px;
    margin-right:7px;
  }
  .title{
    height:auto;
    font-size:12px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:17px;
  }
  .goods-sku{
    height:14px;
    font-size:10px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:14px;
    margin:10px 0 6px;
  }
  .money{
    width:52px;
    font-size:10px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:14px;
    text-align: right;
    margin-left:20px;
  }
  .much_text{
    height:17px;
    font-size:12px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:17px;
    margin-top: 9px;
    text-align: right;
    letter-spacing:1px;
  }
  .font14{
      font-size: 14px;
      color:#333333;
  }
  .buttons{
    width:67px;
    height:24.5px;
    border-radius:12.5px;
    border:1px solid rgba(153,153,153,1);
    background:none;
    font-size:12px;
font-family:PingFangSC-Regular;
font-weight:400;
color:rgba(102,102,102,1);
text-align: center;
margin-top: 12px;
margin-left:12px;
  }
  .buttonscolor{
      color:#FF760E;
      border-color:#FF760E;
  }
}
</style>
